import { StatusTag } from '@aigc/components';
import { SyncOutlined } from '@ant-design/icons';
import { match, P } from 'ts-pattern';
import { TaskStatusCode, TaskType, type TaskDto } from '../model';
import { getTaskStatus } from '../utils';

export const TaskStatus = (props: { task: TaskDto }) => {
  const { task } = props;

  return match(task.status)
    .with(
      P.union(
        TaskStatusCode.未开始,
        TaskStatusCode.上传资源,
        TaskStatusCode.处理资源,
        TaskStatusCode.校验资源,
        TaskStatusCode.校验图片,
      ),
      (status) => (
        <StatusTag
          variant="filled"
          color="default"
          icon={<SyncOutlined spin />}
          active
        >
          {getTaskStatus(status)}
        </StatusTag>
      ),
    )
    .with(
      P.union(
        TaskStatusCode.任务执行中,
        TaskStatusCode.生成视频,
        TaskStatusCode.翻译图片,
        TaskStatusCode.分析视频,
        TaskStatusCode.分析视频2,
        TaskStatusCode.视频编辑准备,
        TaskStatusCode.视频编辑合成,
        TaskStatusCode.画质提升,
      ),
      (status) => (
        <StatusTag
          variant="filled"
          color="processing"
          icon={<SyncOutlined spin />}
          active
        >
          {task.type === TaskType.爆款生成 &&
          status === TaskStatusCode.任务执行中
            ? '分析中'
            : getTaskStatus(status)}
        </StatusTag>
      ),
    )
    .with(TaskStatusCode.任务成功, (status) => (
      <StatusTag variant="filled" color="success">
        {getTaskStatus(status)}
      </StatusTag>
    ))
    .with(TaskStatusCode.任务失败, (status) => (
      <StatusTag variant="filled" color="error">
        {getTaskStatus(status)}
      </StatusTag>
    ))
    .exhaustive(() => (
      <StatusTag
        variant="filled"
        color="processing"
        icon={<SyncOutlined spin />}
        active
      >
        任务执行中
      </StatusTag>
    ));
};

TaskStatus.isSucceeded = (status?: string) => {
  return status === 'success' || status === 'succeeded';
};

TaskStatus.isFailed = (status?: string) => {
  return status === 'failed' || status === 'fail';
};

TaskStatus.isSettled = (status?: string) => {
  return TaskStatus.isFailed(status) || TaskStatus.isSucceeded(status);
};
